import AbsComponent from '../../components/AbsComponent';

import { summary } from './TemplItemSummary';
import { attribute } from './TemplItemAttribute';
import { setitem } from './TemplItemSetitem';
import { obtainable } from './TemplItemObtainable';

export default class TemplItem extends AbsComponent {
    constructor(_name = '', _store = {}, _actions = {}, _router = {}, _el = '') {
        super(_name, _store, _actions, _router, _el);
    }

    loadData(_id, _option = 0, _callback) {
        this.loading = jQuery('.swiper-wrapper .nc-community-loader');
        let state = this.store.getState();
        this.itemId = _id;
        this.enchant = _option;

        this.loading.addClass('is-show').show();
        $(this.el).hide();

        axios({
            method: 'GET',
            url: `${state.config.apiDomain}/game/items/${_id}`,
            withCredentials: window.isLoginFlag === 'true',
            params: { locale: state.config.locale },
        })
            .then((_res) => {
                this.render(_res.data);
                this.addEvents();
                _callback(this.name);
            })
            .catch((error, d) => console.log(error, 'load----', d))
            .then((d) => {
                this.loading.removeClass('is-show').hide();
            });
    }

    render(it = {}) {
        const l10n = this.store.getState().config.l10n;
        this.templ = `
        <div class="gameinfo-detail__list" data-type="item">
            <div class="gameinfo-detail__left">
                ${summary(l10n, it, this.enchant, this.store.getState().defaultThumb)}
                ${attribute(l10n, it, this.enchant)}
            </div>
            <div class="gameinfo-detail__right">
                ${setitem(l10n, it)}
                ${obtainable(l10n, it)}
            </div>
        </div>`;
        $(this.el).show();
        $(this.el).html(this.templ);
    }

    addEvents() {
        $(this.el + ' .select').on('click', (e) => {
            $(this.el + ' .option').toggle();
        });

        $(document).on('click', (e) => {
            if (!$(e.target).hasClass('selectedCategory')) {
                $(this.el + ' .option').toggle(false);
            }
        });
    }
} // end of class
